import React, { useRef, useState, useEffect } from "react";
import { Card, Row, Col } from "react-bootstrap";
import voltupLogo from "../../assets/images/voltup-logo.png";
import "./../../assets/css/otp-component.css";
import { useVerifyOTPMutation } from "../api/verifyOTPApiSlice";
import Loading from "./Loading";

const VerifyOTPCard = (props) => {
  const errRef = useRef();
  const [errorMessage, setErrorMessage] = useState("");
  const inputs = useRef([]);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [otp, setOtp] = useState(['', '', '', '']);
  const [verifyOTP, {isLoading}] = useVerifyOTPMutation();

  useEffect(() => {
    inputs.current[0].focus();
  }, []);

  const handlePaste = (event) => {
    event.preventDefault();

    const pastedValue = (event.clipboardData || window.clipboardData).getData(
      "text"
    );
    const otpLength = inputs.current.length;

    for (let i = 0; i < otpLength; i++) {
      if (i < pastedValue.length) {
        inputs.current[i].value = pastedValue[i];
        inputs.current[i].removeAttribute("disabled");
        inputs.current[i].focus();
      } else {
        inputs.current[i].value = ""; 
        inputs.current[i].focus();
      }
    }
  };

  const handleKeyUp = (index, e) => {
    const currentInput = inputs.current[index];
    const nextInput = inputs.current[index + 1];
    const prevInput = inputs.current[index - 1];
  
    if (currentInput.value.length > 1) {
      currentInput.value = "";
      return;
    }
  
    if (e.key === "Backspace" && index === 0) {
      currentInput.value = "";
      return;
    }
  
    if (nextInput && nextInput.hasAttribute("disabled") && currentInput.value !== "") {
      nextInput.removeAttribute("disabled");
      nextInput.focus();
    }
  
    if (e.key === "Backspace") {
      inputs.current.slice(index).forEach((input) => {
        input.setAttribute("disabled", true);
        input.value = "";
      });
      prevInput?.focus();
    }
  
    setDisableSubmit(inputs.current.some((input) => input.disabled || input.value === ""));
  };
  
  useEffect(() => {
    if (errorMessage != "") {
      setDisableSubmit(true);
    }
  }, [errorMessage]);

  if(isLoading){
    return <Loading />
  }

  const handleVerify = async () => {
    const updatedOtp = inputs.current.map((input) => input.value).join('');
    try {
      let response = await verifyOTP({ verify: { mobile_number: props.mobileNumber, otp: updatedOtp } }).unwrap();
      props.onSuccess();
    } catch (err) {
      if (!err?.status) {
        // isLoading: true until timeout occurs
        setErrorMessage("No Server Response");
      } else if (err.status === 400) {
        setErrorMessage("Missing Username or Password");
      } else if (err.status === 401) {
        setErrorMessage("Unauthorized / Wrong OTP Input");
      } else {
        setErrorMessage("Something went wrong");
      }
      errRef.current.focus();
    }
  }

  return (
    <React.Fragment>
      <Card className="login-card">
          <Card.Img variant="top" src={voltupLogo} />
          <Card.Body>
            <Row>
              <Col md={{ span: 10, offset: 1 }}>
                <div ref={errRef}>{errorMessage}</div>
                <Row className="mb-2">

                  <h4 className="text-center">Verify</h4>
                  <p>Your code has been sent to you via registered mobile number
                    +91 {props.mobileNumber.slice(0, 2) + "******" + props.mobileNumber.slice(-2)}</p> 

                </Row>
                <Row className="mb-4">
                  <div className="otp-field">
                     {[0, 1, 2, 3].map((index) => (
                       <input
                         key={index}
                         type="number"
                         ref={(el) => (inputs.current[index] = el)}
                         onPaste={handlePaste}
                         onKeyUp={(e) => handleKeyUp(index, e)}
                         defaultValue={otp[index]}
                         disabled={index !== 0}
                       />
                     ))}
                  </div>
                </Row>
                <Row className="mb-4">
                  <Col>
                    <button className="btn" onClick={props.onBackClick}>Back</button>
                  </Col>
                  <Col>
                  <button className="btn" onClick={handleVerify} disabled={disableSubmit}>
                      Verify
                  </button>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <p className="resend text-muted mb-0">
                    Didn't receive code?
                    <button onClick={props.onBackClick} className="btn-link">Request again</button>
                  </p>
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Card>
    </React.Fragment>

  );
};

export default VerifyOTPCard;
